export function getHumanReadableRouteById (){
  return ( route ) => `${route.loading_port} > ${route.unloading_port}`;
}


/** WEBPACK FOOTER **
 ** ./frontend/components/booking/getHumanReadableRouteById.filter.js
 **/